import React from 'react';
import _ from 'lodash';

import styles from './Menu.module.scss';
import MenuItem from './MenuItem/MenuItem';
import VideoPlayback from './VideoPlayback/VideoPlayback';
import Label from '../context/Label/Label';
import { VERSION } from '../constants/version';

function Menu({ globalState }) {
  const {
    getCurrentPage,
    getPages,
    goPage,
    getTracking,
    player,
    isNavigationModeFree,
  } = globalState;
  const pages = getPages();
  const currentPage = getCurrentPage();

  function getIcon(type) {
    switch (type) {
      case 'video':
      case 'youtube':
        return 'video';
      case 'quiz':
        return 'edit';
      default:
        return 'bars';
    }
  }

  return (
    <div className={styles.Menu}>
      {!_.isEmpty(currentPage?.facevideo?.name) && player.showMenu && (
        <VideoPlayback
          videoMetadata={currentPage?.facevideo}
          pageResourceId={currentPage?.resourceId}
          globalState={globalState}
        />
      )}
      <div className={styles.Menu__title}>
        <Label>Table of Contents</Label>
      </div>
      <div className={styles.Menu__list}>
        {_.map(pages, (page, i) => {
          const _trackingPrevPage = getTracking(pages[i - 1]?.resourceId);
          const _tracking = getTracking(page.resourceId);
          return (
            <MenuItem
              key={i}
              completed={_tracking.completed}
              active={currentPage?.resourceId === page.resourceId}
              disabled={
                !_trackingPrevPage.completed &&
                !_tracking.completed &&
                !isNavigationModeFree &&
                i > 0 // not first page
              }
              icon={getIcon(page.type)}
              onClick={() => goPage(i + 1)}
              globalState={globalState}
            >
              {page.title || `Page ${i + 1}`}
            </MenuItem>
          );
        })}
      </div>
      <div className={styles.Menu__bottom}>{VERSION}</div>
    </div>
  );
}

export default Menu;
